var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 96,
    viewBox: "0 0 102 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_14831_240169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.0997 74.1755C83.5793 74.1755 100.181 57.5708 100.181 37.0878C100.181 16.6048 83.5793 0 63.0997 0C42.6201 0 26.0181 16.6048 26.0181 37.0878C26.0181 57.5708 42.6201 74.1755 63.0997 74.1755Z",
    fill: "#ECF3FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M92.0359 64.8547H46.0126C44.8584 64.8547 43.9233 63.9179 43.9233 62.7616V26.7533C43.9233 25.597 44.8584 24.6602 46.0126 24.6602H92.0359C93.1902 24.6602 94.1252 25.597 94.1252 26.7533V62.7579C94.1252 63.9143 93.1902 64.8547 92.0359 64.8547Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.25,
    d: "M56.094 80.8569H10.0708C8.91652 80.8569 7.98145 79.9201 7.98145 78.7637V42.7592C7.98145 41.6028 8.91652 40.666 10.0708 40.666H56.094C57.2482 40.666 58.1833 41.6028 58.1833 42.7592V78.7637C58.187 79.9201 57.2519 80.8569 56.094 80.8569Z",
    fill: "#3A7EC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M58.6067 78.6616H12.5835C11.4292 78.6616 10.4941 77.7248 10.4941 76.5684V40.5639C10.4941 39.4075 11.4292 38.4707 12.5835 38.4707H58.6067C59.761 38.4707 60.696 39.4075 60.696 40.5639V76.5684C60.6997 77.7248 59.761 78.6616 58.6067 78.6616Z",
    fill: "#FFCB48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.2344 54.3971L30.2183 68.9688L40.9461 68.9807L40.9623 54.4091L30.2344 54.3971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M38.6563 69.5692L35.5588 66.7734L32.4541 69.5619L34.5142 71.5233L33.8129 75.7535H35.5479L37.2829 75.7572L36.5889 71.527L38.6563 69.5692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.8577 57.8546H30.2294C29.2797 57.8546 28.5017 57.0752 28.5054 56.1237C28.5054 55.1723 29.2834 54.3928 30.2331 54.3965H30.8613C31.811 54.3965 32.589 55.1759 32.5854 56.1274C32.5854 57.0788 31.8074 57.8546 30.8577 57.8546Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.9573 57.8663H40.329C39.3793 57.8663 38.6013 57.0869 38.605 56.1354C38.605 55.184 39.383 54.4046 40.3327 54.4082H40.9609C41.9106 54.4082 42.6886 55.1877 42.685 56.1391C42.685 57.0906 41.907 57.8663 40.9573 57.8663Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.3,
    d: "M40.957 57.4133L40.9534 61.274C40.0146 63.2171 37.1692 67.462 30.2183 67.5864L30.2292 57.4023L40.957 57.4133Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M39.8469 45.7285C39.8469 45.7285 44.8547 45.3589 41.4248 54.9318H39.8359L39.8469 45.7285Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.4968 48.8238C40.4968 48.8238 42.5167 44.5204 37.5455 43.6751C32.5742 42.8298 28.3664 47.0563 28.5125 48.6262C28.6586 50.1997 29.769 54.9167 29.769 54.9167L40.4968 48.8238Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M41.5672 49.5339L41.5599 57.2917C41.5563 60.7425 38.5976 63.5273 35.102 63.2419C31.9827 62.9857 29.6267 60.2888 29.6304 57.1563L29.6377 49.5192C29.6377 48.9411 30.1089 48.4727 30.686 48.4727L40.5226 48.4836C40.8111 48.4836 41.0741 48.6007 41.264 48.791C41.4503 48.9813 41.5672 49.2448 41.5672 49.5339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M32.6441 69.6821L29.0718 69.6785L29.616 66.7656L35.5552 66.7729C35.5552 68.3831 34.2512 69.6858 32.6441 69.6821Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M38.4624 69.6897L42.0347 69.6934L41.4978 66.7769L35.5586 66.7695C35.5549 68.3833 36.8553 69.6897 38.4624 69.6897Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.3,
    d: "M37.3374 48.48C34.8208 49.0325 30.8357 50.7488 29.6304 56.0988L29.6377 49.5192C29.6377 48.9411 30.1089 48.4727 30.686 48.4727L37.3374 48.48Z",
    fill: "#EAA244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M35.6538 57.932C34.3827 57.932 33.4147 57.4051 33.3563 57.3721C33.1043 57.2331 33.013 56.911 33.1518 56.6586C33.2906 56.4061 33.6083 56.3146 33.8604 56.4536C33.9371 56.4939 35.6283 57.3941 37.2756 56.4609C37.5276 56.3182 37.8454 56.4061 37.9879 56.6586C38.1303 56.911 38.0427 57.2294 37.7906 57.3721C37.0491 57.7929 36.3113 57.932 35.6538 57.932Z",
    fill: "#F9C067"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.25,
    d: "M83.9744 59.5854H37.9511C36.7969 59.5854 35.8618 58.6486 35.8618 57.4923V21.4877C35.8618 20.3313 36.7969 19.3945 37.9511 19.3945H83.9744C85.1286 19.3945 86.0637 20.3313 86.0637 21.4877V57.4923C86.0637 58.6486 85.1286 59.5854 83.9744 59.5854Z",
    fill: "#3A7EC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M86.1111 57.185H40.0878C38.9336 57.185 37.9985 56.2482 37.9985 55.0919V19.0873C37.9985 17.9309 38.9336 16.9941 40.0878 16.9941H86.1111C87.2653 16.9941 88.2004 17.9309 88.2004 19.0873V55.0919C88.204 56.2482 87.269 57.185 86.1111 57.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.21,
    d: "M71.7488 53.739H54.4463C55.4982 51.8618 57.2661 50.4346 59.3737 49.8345C59.3737 49.8308 59.3774 49.8308 59.3774 49.8308C59.7463 49.7247 60.1261 49.6479 60.5133 49.5966C60.5279 49.593 60.5425 49.593 60.5608 49.5893C60.8895 49.5454 61.2292 49.5234 61.5726 49.5234H64.586C64.6043 49.5234 64.6262 49.5234 64.6445 49.5234C64.9769 49.5234 65.3056 49.5491 65.627 49.5893C65.6416 49.5893 65.6562 49.593 65.6745 49.5966C66.0653 49.6442 66.4416 49.7284 66.8141 49.8308H66.8178C68.9254 50.4346 70.6969 51.8618 71.7488 53.739Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M71.4491 36.0493V45.6808C71.4491 47.8032 69.7324 49.5231 67.6139 49.5231H58.5772C56.4623 49.5231 54.7456 47.8032 54.7456 45.6808V36.0493C54.7456 27.4937 63.0992 27.8816 63.0992 27.8816C63.0992 27.8816 65.2725 27.7828 67.402 28.822C69.3087 29.7479 71.1788 31.5922 71.4199 35.2369C71.4418 35.4967 71.4491 35.7675 71.4491 36.0493Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M65.6783 48.1065V50.9389C65.6783 52.1392 64.5167 53.1235 63.0959 53.1235C61.675 53.1235 60.5171 52.1392 60.5171 50.9389V48.1065C60.5171 47.6125 60.7143 47.1514 61.0467 46.7855C61.1234 46.6977 61.2074 46.6172 61.2988 46.544C61.4741 46.4013 61.6713 46.2768 61.8868 46.178C62.2484 46.0134 62.6575 45.9219 63.0959 45.9219C63.5305 45.9219 63.9433 46.0134 64.3049 46.178C64.5204 46.2768 64.7176 46.3976 64.893 46.5403C64.9003 46.5476 64.9112 46.5549 64.9185 46.5623C64.9989 46.6318 65.0756 46.705 65.145 46.7818C65.481 47.1514 65.6783 47.6125 65.6783 48.1065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.21,
    d: "M70.1053 38.2308V42.3549C70.1053 45.2532 68.2534 47.7379 65.6783 48.6857V49.7725C64.9587 50.0396 64.1807 50.1824 63.3735 50.1824H62.8219C62.011 50.1824 61.2367 50.036 60.5171 49.7725V48.6857C57.942 47.7379 56.0938 45.2495 56.0938 42.3549V38.2308C56.1011 36.295 56.9375 34.5458 58.2598 33.3199C59.4615 32.2038 61.065 31.5195 62.8219 31.5195H63.3735C64.9514 31.5195 66.4052 32.0721 67.5558 32.9906C69.1008 34.2238 70.0943 36.1157 70.1053 38.2308Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M70.105 37.172V42.3536C70.105 43.7698 69.6631 45.0872 68.9106 46.174C68.907 46.1777 68.907 46.1777 68.907 46.1777C68.7316 46.4302 68.5417 46.668 68.3335 46.8949C67.9317 47.334 67.4751 47.7219 66.9711 48.0403C66.5656 48.2965 66.1346 48.5124 65.678 48.6843C64.9585 48.9515 64.1804 49.0942 63.3732 49.0942H62.8217C62.0144 49.0942 61.2364 48.9515 60.5168 48.6843C57.9417 47.7366 56.0898 45.2519 56.0898 42.35V37.1976C56.0898 37.1244 56.0935 37.0549 56.0935 36.9817C56.1483 35.0166 57.0505 33.2564 58.4458 32.0562C58.665 31.8659 58.8987 31.6902 59.1435 31.5292C60.1991 30.8339 61.4665 30.4277 62.8217 30.4277H63.3732C64.8964 30.4277 66.3063 30.9437 67.4386 31.8073C68.0413 32.2684 68.5636 32.8246 68.9837 33.4577C69.1553 33.7175 69.3088 33.9883 69.4439 34.2701C69.8713 35.152 70.105 36.1364 70.105 37.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M72.8006 39.9018C72.8006 41.3948 71.5916 42.6024 70.105 42.6024V37.2012C70.4775 37.2012 70.8355 37.278 71.1569 37.4171C71.1606 37.4171 71.1606 37.4207 71.1606 37.4207C72.1249 37.8306 72.8006 38.7893 72.8006 39.9018Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M71.7742 39.9009C71.7742 40.823 71.0254 41.5732 70.105 41.5732V38.2285C71.0254 38.2285 71.7742 38.9787 71.7742 39.9009Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M66.8213 49.834L65.6816 53.7385H60.5132L59.3735 49.834H59.3808H60.5168H60.7981L60.8492 49.8852L63.0992 52.2162L65.3456 49.8889L65.3493 49.8852L65.4004 49.834H66.8213Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M56.0936 37.2012V42.6024C54.607 42.6024 53.3979 41.3948 53.3979 39.9018C53.3979 38.6174 54.2892 37.5452 55.4872 37.2707C55.5274 37.2597 55.5713 37.2524 55.6151 37.2451C55.637 37.2414 55.6589 37.2378 55.6845 37.2341C55.816 37.2122 55.9548 37.2012 56.0936 37.2012Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M54.4243 39.9009C54.4243 40.823 55.1731 41.5732 56.0936 41.5732V38.2285C55.1731 38.2285 54.4243 38.975 54.4243 39.9009Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M66.8214 49.8345L65.0645 53.5048L63.0957 52.2167L65.3969 49.8345L65.7 49.5234L66.8214 49.8345Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M63.0956 52.2167L61.1305 53.5048L59.3735 49.8345L60.4986 49.5234L60.7981 49.8345L63.0956 52.2167Z",
    fill: "#B3CEF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M71.4494 35.87C66.427 36.2322 66.9055 31.68 67.4315 29.4551C69.3382 30.3846 71.2083 32.2252 71.4494 35.87Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M68.8852 31.9148C68.7135 32.1929 66.9822 35.3143 63.8665 35.3143C60.7508 35.3143 55.8051 37.1879 55.6517 40.2984C55.4983 43.4052 51.7507 30.806 61.2146 29.8253C70.675 28.8409 68.8852 31.9148 68.8852 31.9148Z",
    fill: "#3B82F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M84.1462 23.8592H82.097C81.9582 23.8592 81.8486 23.7458 81.8486 23.6104V21.327C81.8486 21.1879 81.9619 21.0781 82.097 21.0781H84.1462C84.285 21.0781 84.3946 21.1916 84.3946 21.327V23.6104C84.3946 23.7458 84.285 23.8592 84.1462 23.8592Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M83.0539 24.6605H78.3968C78.1083 24.6605 77.8745 24.4263 77.8745 24.1372V20.7889C77.8745 20.4998 78.1083 20.2656 78.3968 20.2656H83.0539C83.3425 20.2656 83.5763 20.4998 83.5763 20.7889V24.1372C83.5726 24.4263 83.3388 24.6605 83.0539 24.6605Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M81.5196 22.659C81.623 22.2204 81.3519 21.7809 80.9141 21.6773C80.4763 21.5737 80.0376 21.8453 79.9342 22.284C79.8309 22.7226 80.102 23.1621 80.5398 23.2657C80.9776 23.3692 81.4163 23.0976 81.5196 22.659Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    opacity: 0.25,
    d: "M30.2183 16.303L20.0859 8.49023L19.5636 12.4241C15.8306 12.8156 12.4263 14.111 9.42751 16.2847C0.953385 22.4288 0.416447 32.0749 0.394531 33.9448L5.3256 34.0034C5.33655 33.1105 5.61781 25.144 12.3168 20.2881C14.2819 18.8609 16.4844 17.9314 18.8879 17.5033L18.3984 21.1883L30.2183 16.303Z",
    fill: "#3A7EC1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M0.0185883 33.6946C-0.0727278 31.8246 -0.123865 22.1639 7.95943 15.5148C11.1957 12.8545 15.0127 11.2809 19.3082 10.8418L19.8086 15.7563C16.4957 16.0967 13.5589 17.3006 11.0861 19.3315C4.69762 24.5901 4.89852 32.5602 4.94235 33.4494L0.0185883 33.6946Z",
    fill: "#3B82F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M17.2114 19.8628L28.7136 14.2676L18.1282 7.08789L17.2114 19.8628Z",
    fill: "#3B82F4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    opacity: 0.25,
    d: "M89.0114 72.8438C88.8762 73.7257 87.4663 81.5714 80.1501 85.4283C78.0023 86.5591 75.6902 87.1702 73.2539 87.2507L74.2584 83.6718L61.8687 86.8262L70.792 96.0003L71.8659 92.1835C75.6172 92.3263 79.1712 91.5249 82.4476 89.8013C91.7034 84.9233 93.5991 75.4492 93.8877 73.6012L89.0114 72.8438Z",
    fill: "#3A7EC1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M93.6503 70.0586C93.5078 71.9248 92.3499 81.516 83.4959 87.0966C79.9528 89.3288 75.9678 90.412 71.6504 90.3058L71.7673 85.3657C75.0985 85.4462 78.1594 84.6192 80.8697 82.9139C87.8681 78.5007 88.6644 70.5709 88.7338 69.6816L93.6503 70.0586Z",
    fill: "#FFCB48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M74.8609 81.623L62.7524 85.7325L72.3552 94.1857L74.8609 81.623Z",
    fill: "#FFCB48"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M50.0668 6.10706C51.6403 6.10706 52.9159 4.82914 52.9159 3.25275C52.9159 1.67636 51.6403 0.398438 50.0668 0.398438C48.4933 0.398438 47.2178 1.67636 47.2178 3.25275C47.2178 4.82914 48.4933 6.10706 50.0668 6.10706Z",
    fill: "#52D1BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M24.5759 87.1859C24.7365 86.1944 24.0644 85.2602 23.0748 85.0993C22.0851 84.9384 21.1526 85.6117 20.992 86.6032C20.8314 87.5947 21.5035 88.5289 22.4931 88.6898C23.4828 88.8507 24.4153 88.1774 24.5759 87.1859Z",
    fill: "#52D1BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M100.185 61.405C101.188 61.405 102 60.5907 102 59.5863C102 58.5818 101.188 57.7676 100.185 57.7676C99.1824 57.7676 98.3696 58.5818 98.3696 59.5863C98.3696 60.5907 99.1824 61.405 100.185 61.405Z",
    fill: "#52D1BD"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14831_240169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovement);
export default __webpack_public_path__ + "static/media/movement.b9671e43ac2b9fb11464a615ff96e6ff.svg";
export { ForwardRef as ReactComponent };